import { createApp               } from 'vue'
import   router                    from './router';
import { createPinia             } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import checkPermision from '@/core/directiveCoreCheckPermission';
import  tooltipDirective    from '@/core/directiveCoreToolTip'; 
import { AxiosInterceptor } from '@/core/axiosCoreInterceptor';

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

const options = {
    position: "bottom-left",
    timeout: 7000,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: "button",
    icon: true
};


import '../node_modules/admin-lte/plugins/fontawesome-free/css/all.min.css';
import '../node_modules/admin-lte/plugins/overlayScrollbars/css/OverlayScrollbars.min.css';
import '../node_modules/admin-lte/dist/css/adminlte.min.css';
import '@/assets/css/site.css';

import '../node_modules/admin-lte/plugins/jquery/jquery.min.js';
import '../node_modules/admin-lte/plugins/bootstrap/js/bootstrap.bundle.min.js';
import '../node_modules/admin-lte/plugins/overlayScrollbars/js/jquery.overlayScrollbars.min.js';
import '../node_modules/admin-lte/dist/js/adminlte.js';

/*tablet */
import dynamicTable             from '@/core/baseComponent/table/DynamicTable.vue';
import tableToolbar             from '@/core/baseComponent/table/TableToolbar.vue';


/*pagination */
import paginationButtons from '@/core/baseComponent/paginator/paginatorButtons.vue';
import itemsButtons from '@/core/baseComponent/paginator/itemsPageButtons.vue';
import sortColum from '@/core/baseComponent/paginator/sortColum.vue';
import loadingPaginator from '@/core/baseComponent/paginator/loadingPaginator.vue';
/*forms */
import areaInput   from './core/baseComponent/forms/areaInput.vue';
import textInput from '@/core/baseComponent/forms/textInput.vue';
import numberInput   from '@/core/baseComponent/forms/numberInput.vue';
import selectInput from '@/core/baseComponent/forms/selectInput.vue';
import dateInput from '@/core/baseComponent/forms/dateTime/dateInput.vue';
import dateEndInput   from '@/core/baseComponent/forms/dateTime/dateEndInput.vue';
import dateInputMin from '@/core/baseComponent/forms/dateTime/dateInputMin.vue';
import dateEndInputMax   from '@/core/baseComponent/forms/dateTime/dateEndInputMax.vue';
import btnTemplate from '@/core/baseComponent/forms/btnTemplate.vue';
/*modal*/
import modalBase from '@/core/baseComponent/modal/modalTeleport.vue';
import modalHead from '@/core/baseComponent/modal/modalHead.vue';   
/*cards*/
import cardBase from '@/core/baseComponent/cards/cardBase.vue';
import cardHead from '@/core/baseComponent/cards/cardHeadCustom.vue';
/*table*/
import tbodyEmpaty from '@/core/baseComponent/table/tbodyEmpaty.vue';
/*box*/
import boxTemplate from '@/core/baseComponent/box/boxTemplate.vue'
/*ul-li*/
import liDetail from '@/core/baseComponent/list/liDetail.vue'

import App from './App.vue'

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

AxiosInterceptor();

const myApp = createApp(App);
myApp.component('dynamicTable', dynamicTable);
myApp.component('tableToolbar', tableToolbar);

myApp.component('paginationButtons', paginationButtons);
myApp.component('itemsButtons', itemsButtons);
myApp.component('sortColum', sortColum);
myApp.component('loadingPaginator', loadingPaginator);

myApp.component('areaInput', areaInput);
myApp.component('textInput', textInput);
myApp.component('numberInput', numberInput);
myApp.component('selectInput', selectInput);
myApp.component('dateInput', dateInput);
myApp.component('dateEndInput', dateEndInput);
myApp.component('dateInputMin', dateInputMin);
myApp.component('dateEndInputMax', dateEndInputMax);
myApp.component('modalHead', modalHead);
myApp.component('BtnTemplate', btnTemplate);
myApp.component('cardBase', cardBase);
myApp.component('modalBase', modalBase);
myApp.component('cardHead', cardHead);
myApp.component('tbodyEmpaty', tbodyEmpaty);
myApp.component('boxTemplate', boxTemplate);
myApp.component('liDetail',liDetail);

myApp.directive('tooltip', tooltipDirective);
myApp.directive('checkPermision', checkPermision);
myApp.use(Toast, options);
myApp.use(router);
myApp.use(pinia);
myApp.mount('#app')
